import React from 'react'
import {useFormContext} from 'react-hook-form'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {useCentral} from '../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../models'
import {valueIdCountry} from '../../../../../util/Constants'
interface Props {
  loading?: boolean
  updateClick?: () => void
  deleteClick?: () => void
  textComponentGo?: string
  textComponentBack?: string
}
const ActionsContent = ({
  loading,
  updateClick,
  deleteClick,
  textComponentGo = '',
  textComponentBack = '',
}: Props) => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {reset, setValue} = useFormContext()
  const handleShowNewForm = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
      idToDelete: '',
      content: {
        headerPanel: textComponentGo,
      },
      editOnBottomPanel: false,
    }
    changeCurrentTabItem(obj)
    reset()
  }
  const handleBack = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      content: {
        headerPanel: textComponentBack,
      },
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleRestText = () => {
    reset()
    setValue('paisId', valueIdCountry)
    const obj: TabCentralModel = {
      ...currentTabItem,
      reset: true,
    }
    changeCurrentTabItem(obj)
  }

  const getDisabledDelete = currentTabItem.idToDelete ? false : true
  return (
    <ButtonWrapper>
      {currentTabItem.content.headerPanel === textComponentBack && isAllowed('NUEVO') && (
        <Button label='Nuevo' onClick={handleShowNewForm} />
      )}
      {(currentTabItem.content.headerPanel === textComponentGo || currentTabItem.showPanel) &&
        !currentTabItem.editOnBottomPanel && (
          <Button typeBtn='submit' label='Guardar' loading={loading} disabled={loading} />
        )}
      {currentTabItem.content.headerPanel === textComponentGo && (
        <Button label='Limpiar' onClick={() => handleRestText()} />
      )}
      {isAllowed('ELIMINAR') && (
        <Button label='Eliminar' disabled={getDisabledDelete} onClick={deleteClick} />
      )}
      {currentTabItem.content.headerPanel === textComponentGo && (
        <Button label='Volver al listado' classNameProp='ms-auto' onClick={handleBack} />
      )}
    </ButtonWrapper>
  )
}

export default ActionsContent
